import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { useLazyQueryTagsWithPipelineCount } from '@ion/api';

import useServerPagination from 'app/shared/hooks/data-table/useServerPagination';
import useModalState from './useModalState';

const TAGS_PER_PAGE = 10;
const DEFAULT_SORT = {
  field: 'label',
  direction: 'asc',
};

const PipelineTagsTableContextValue = createContext({});

export default function PipelineTagsTableContext({ children }) {
  const [fetchPipelineTags, { tags, pagination, loading }] = useLazyQueryTagsWithPipelineCount();

  const { resetPagination, setActivePage, onSort } = useServerPagination({
    perPage: TAGS_PER_PAGE,
    defaultSort: DEFAULT_SORT,
    fetchData: fetchPipelineTags,
  });

  const modalState = useModalState();

  return (
    <PipelineTagsTableContextValue.Provider
      value={{
        tags,
        pagination,
        loading,
        perPage: TAGS_PER_PAGE,
        resetPagination,
        setActivePage,
        onSort,
        ...modalState,
      }}
    >
      {children}
    </PipelineTagsTableContextValue.Provider>
  );
}

export function usePipelineTagsTableContext() {
  return useContext(PipelineTagsTableContextValue);
}

PipelineTagsTableContext.propTypes = {
  children: PropTypes.node.isRequired,
};
